import {
  FilterPaginationDirectory,
  FilterPointsDirectory,
  landingType,
  showReCaptcha
} from '@/infrastructure/Configuration'

export default {
  offers: [],
  landingType,
  currentCustomer: {},
  labelsLoaded: false,
  hotels: [],
  directory: {
    hotels: [],
    countries: [],
    states: [],
    cities: [],
    selectedCountry: null,
    selectedState: null,
    selectedCity: null,
    points: {
      min: FilterPointsDirectory.MIN,
      max: FilterPointsDirectory.MAX
    },
    pagination: {
      offset: FilterPaginationDirectory.OFFSET,
      limit: FilterPaginationDirectory.LIMIT,
      total: null
    }
  },
  tripAdvisorRating: [],
  countries: [],
  brands: [],
  hotelTypes: [],
  selectedBrands: [],
  selectedHotelTypes: [],
  selectedOfferCountry: null,
  selectedOfferCity: null,
  isOnlyRewards: false,
  center: { latitude: 0, longitude: 0 },
  zoom: 3,
  loading: 0,
  focus: '',
  checkInDate: null,
  checkOutDate: null,
  lastFilter: {},
  loadingPrice: false,
  fromPrice: {
    amount: 0.0
  },
  customerProfile: {},
  customerSummary: {},
  loadingCustomer: false,
  preferences: {},
  showSubscriptionBanner: false,
  loadingPreferences: false,
  loadingNewsletter: false,
  loadingInvoice: false,
  currentFavHotel: {},
  coBrandImages: {},
  showTransliteratedField: false,
  transliterableLanguagesLoaded: false,
  currentLanguege: window.languages && window.languages.length > 0 ? window.languages[0].activeLanguage : 'en-us',
  currentModalId: '',
  isFormEdited: false,
  isChangeDiscarded: false,
  reCaptchaEnabled: showReCaptcha(),
  reservations: {
    reservations: [],
    B2BBusinessReservations: {
      memberType: '',
      reservationsList: []
    },
    B2BPersonalReservations: {
      memberType: '',
      reservationsList: []
    },
    loading: false,
    total: 0,
    page: 0,
    groupType: 'future',
    memberType: '',
    filters: {
      firstName: '',
      lastName: ''
    }
  },
  reservationsWithExploreHotel: [],
  noReservations: {},
  currentView: '',
  inviteMember: {},
  transactions: {
    transactions: [],
    loading: false,
    filterApplied: false,
    total: 0,
    page: 1,
    filters: {
      type: '',
      filter: '',
      dateFrom: '',
      dateTo: ''
    }
  },
  loadingClaimPoints: false,
  appleTreeBannerInfo: {}
}
